import { createContext } from 'react';

import type { PetitionStatsState } from './apiPetitionStats';

export const PetitionStatsContext = createContext<PetitionStatsState | undefined>(undefined);
